import { CustomerOrganization } from "../../utils/interfaces";

interface CustomerEscalationAgentSectionProps {
  customer: CustomerOrganization;
}

export function CustomerEscalationAgentSection({
  customer,
}: CustomerEscalationAgentSectionProps) {
  const agent = customer.accounting_agent;
  if (!agent) {
    return null;
  }

  return (
    <section className="rounded-lg border border-slate-200 bg-slate-50 p-4">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
        agent
      </h2>
      <dl className="mt-3 grid gap-2 text-sm text-slate-800 sm:grid-cols-4">
        <div>
          <dt className="text-slate-500">Name</dt>
          <dd className="font-medium text-slate-900">{agent.name}</dd>
        </div>
        <div>
          <dt className="text-slate-500">Code</dt>
          <dd className="font-medium text-slate-900">{agent.agent_code}</dd>
        </div>
        {agent.email ? (
          <div className="sm:col-span-2">
            <dt className="text-slate-500">Email</dt>
            <dd className="font-medium text-slate-900">{agent.email}</dd>
          </div>
        ) : null}
      </dl>
    </section>
  );
}
